import { createContext } from './createContext';
import { createApplicationState } from '../applicationState';
import { initClsDebug } from '../clsDebug';
import { renderApplication } from '../renderApplication';

export function runApp(): void {
  const context = createContext();

  const store = createApplicationState(context);

  renderApplication({ context, store });

  /* Временная диагностика CLS. Удалить вместе с services/clsDebug, когда причина найдена. */
  const { user, offers } = store.getState();

  initClsDebug({
    isAuthenticated: Boolean(user?.isAuthenticated),
    offersTotal: offers?.totalCount ?? null,
  });
}
